import { FC } from 'react';
import {
  Box,
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';

import { Channel } from 'types/customer';
import { ReadonlyForm } from 'components/molecules/ReadonlyForm';

type Props = {
  mode: '登録' | '更新';
  isOpen: boolean;
  name: string;
  detail: string;
  environment: string;
  corporateNumber: string;
  channel: Channel;
  poseidonUrl: string;
  // 登録の際は default true で登録されるため optional にする
  status?: boolean;
  systemUpdateGroup: string;
  iapClientId: string;
  iapClientSecret: string;
  poseidonAgentCpu: string;
  poseidonAgentMemory: string;
  enableVerticalPodAutoScaler: boolean;
  handleClose: () => void;
  handleClickGoInput: () => void;
  handleClickExecution: () => void;
};

export const ConfirmationModalView: FC<Props> = ({
  mode,
  isOpen,
  name,
  detail,
  environment,
  corporateNumber,
  channel,
  poseidonUrl,
  status,
  systemUpdateGroup,
  iapClientId,
  iapClientSecret,
  poseidonAgentCpu,
  poseidonAgentMemory,
  enableVerticalPodAutoScaler,
  handleClose,
  handleClickGoInput,
  handleClickExecution,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={handleClose}
    size="2xl"
    blockScrollOnMount
    closeOnOverlayClick={false}
    closeOnEsc={false}
  >
    <ModalOverlay />
    <ModalContent h="90vh">
      <ModalHeader p="40px 40px 0 40px">顧客情報の{mode}</ModalHeader>
      <ModalCloseButton />
      <ModalBody overflowY="auto" p="0 40px 0 40px">
        <Box mt="40px">
          <ReadonlyForm label="顧客名" value={name} />
        </Box>
        <Box mt="40px">
          <ReadonlyForm label="顧客詳細" value={detail} />
        </Box>
        <Box mt="40px">
          <ReadonlyForm label="GCP プロジェクト名" value={environment} />
        </Box>
        <Box mt="40px">
          <ReadonlyForm label="顧客番号" value={corporateNumber} />
        </Box>
        <Box mt="40px">
          <ReadonlyForm label="契約種別" value={channel} />
        </Box>
        <Box mt="40px">
          <ReadonlyForm label="顧客環境URL" value={poseidonUrl} />
        </Box>
        {status !== undefined && (
          <Box mt="40px">
            <ReadonlyForm
              label="顧客ステータス"
              value={status ? '契約中' : '解約済み'}
            />
          </Box>
        )}
        <Box mt="40px">
          <ReadonlyForm
            label="システム管理上のグループ"
            value={systemUpdateGroup}
          />
        </Box>
        <Box mt="40px">
          <ReadonlyForm label="IAP Client ID" value={iapClientId} />
        </Box>
        <Box mt="40px">
          <ReadonlyForm label="IAP Client Secret" value={iapClientSecret} />
        </Box>
        <Box mt="40px">
          <ReadonlyForm label="Poseidon Agent CPU" value={poseidonAgentCpu} />
        </Box>
        <Box mt="40px">
          <ReadonlyForm
            label="Poseidon Agent Memory"
            value={poseidonAgentMemory}
          />
        </Box>
        <Box mt="40px">
          <ReadonlyForm
            label="Enable Vertical Pod Auto Scaler"
            value={enableVerticalPodAutoScaler ? 'Yes' : 'No'}
          />
        </Box>
      </ModalBody>
      <ModalFooter justifyContent="center" mt="20px" mb="20px">
        <VStack>
          <Text fontSize="lg" textAlign="center">
            上記の内容で顧客情報を{mode}しますか？
          </Text>
          <Box h="20px" />
          <HStack>
            <Button
              colorScheme="gray"
              variant="outline"
              mr={3}
              onClick={handleClickGoInput}
            >
              入力画面へ戻る
            </Button>

            <Button
              width="140px"
              colorScheme="blackAlpha"
              mr={3}
              onClick={handleClickExecution}
            >
              {mode}
            </Button>
          </HStack>
        </VStack>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
